// HighTide About Page JavaScript - Particle Effects

document.addEventListener("DOMContentLoaded", function () {
  initAboutPage();
});

function initAboutPage() {
  initParticleEffects();
  addSmoothScrolling();
  forceShowSections();
}

// Particle Effects
function initParticleEffects() {
  const aboutParticles = document.getElementById("about-hero-particles");

  if (aboutParticles) {
    createParticles(aboutParticles, 30);
  }
}

function createParticles(container, count) {
  for (let i = 0; i < count; i++) {
    const particle = document.createElement("span");
    const size = Math.random() * 4 + 2;
    const startX = Math.random() * 100;
    const duration = Math.random() * 10 + 15;
    const delay = Math.random() * 5;

    particle.style.cssText = `
      position: absolute;
      left: ${startX}%;
      bottom: -10px;
      width: ${size}px;
      height: ${size}px;
      background: rgba(58, 208, 230, 0.6);
      border-radius: 50%;
      pointer-events: none;
      animation: htAboutFloat ${duration}s linear ${delay}s infinite;
      box-shadow: 0 0 10px rgba(58, 208, 230, 0.8);
    `;

    container.appendChild(particle);
  }
}

// Add CSS animation keyframes
function addParticleStyles() {
  const style = document.createElement("style");
  style.textContent = `
    @keyframes htAboutFloat {
      0% {
        transform: translateY(0) rotate(0deg);
        opacity: 0;
      }
      10% {
        opacity: 1;
      }
      90% {
        opacity: 1;
      }
      100% {
        transform: translateY(-100vh) rotate(360deg);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
}

// Smooth Scrolling
function addSmoothScrolling() {
  const links = document.querySelectorAll('a[href^="#"]');

  links.forEach((link) => {
    link.addEventListener("click", function (e) {
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });
}

// Force visibility of all sections
function forceShowSections() {
  const sections = document.querySelectorAll(
    ".ht-about-section, .ht-value-card, .ht-difference-item, .ht-commitment-item"
  );
  sections.forEach((section) => {
    section.style.opacity = "1";
    section.style.visibility = "visible";
    section.style.transform = "translateY(0)";
  });
}

// Initialize particle styles
addParticleStyles();

console.log("HighTide About page initialized");
